import React from 'react';
import { observer } from "mobx-react";
import { Redirect } from "react-router-dom";
import { Card, Avatar, List, Form, Input, Button, Spin, Modal, Result } from 'antd';
import moment from 'moment';
import * as XLSX from 'xlsx';
import * as cptable from 'xlsx/dist/cpexcel.full.mjs';
import CSVStringify from 'csv-stringify';
import { saveAs } from 'file-saver';
import _ from 'lodash';

import { ShippingItemStoreContext } from './AppContexts';
import { PHONE_NO_WITH_PREFIX_RE } from './common';

const OUR_CLIENT_CODE = '106074811';
XLSX.set_cptable(cptable);

@observer
class ExportData extends React.Component {
	static contextType = ShippingItemStoreContext;

	state = {
	};

	getXLSWorkbook = (formatType) => {
		let header = ['bollanum', 'socronchi', 'soc', 'att', '', 'paese', 'cap', 'citta', 'provita', 'tel', 'pesoeff', 'descr', 'collo', 'colli'];
		let data = this.context.printableItems.map( (item) =>{
			return [
				item.deliveryNoteId
				,item.client
				,item.recipient
				,item.attention
				,item.address
				,item.country
				,item.zip
				,item.city
				,item.provinceIT
				,item.phone
				,item.grossWeight
				,item.description
				,item.packageSeq
				,item.packagesTot
			];
		});

		data = [ header, ...data ];
		console.log(data);

		let wb = XLSX.utils.book_new();
		let ws = XLSX.utils.aoa_to_sheet(data);
		XLSX.utils.book_append_sheet(wb, ws, 'bollenatale');
		return wb;
	}

	exportXlsFormat1 = () => {
		let today = new Date();
		let workbook = this.getXLSWorkbook('format1');
		//XLSX.writeFile(workbook, `spedizione-std-${moment(today).format('YY-MM-DD-HHmmss-SSSS')}.xlsx`);
		XLSX.writeFile(workbook, `spedizioni-${moment(today).format('YY-MM-DD-HHmmss-SSSS')}.xlsx`);
	}

	_isItaly = (country) => {
		//keep array in lowercase because country is lower-cased and trimmed
		return (['it', 'italy', 'italia'].indexOf( String(country).toLowerCase().trim() ) !== -1);
	}

	_getDateStr = (date) => {
		return moment(date).format('YYYYMMDD');
	}

	_getPhonePrefix = (phone) => {
		if (!phone) {
			return '';
		}
		let m = String(phone).match(PHONE_NO_WITH_PREFIX_RE);
		return m ? m[1] : '';
	}
	_getPhoneNo = (phone) => {
		if (!phone) {
			return '';
		}
		let m = String(phone).match(PHONE_NO_WITH_PREFIX_RE);
		return m ? m[2] : phone;
	}

	exportCsvDHL = () => {
		let stringifierOptions = {
			delimiter: ';'
			,header: true
			,columns: ['Codice prodotto (3 lettere)','Data','Tipologia di spedizione','Valore dichiarato','Valuta valore dichiarato','VS codice CL','Rif spedizione mittente','Contenuto','Mittente','Contatto mittente','Indirizzo 1 mittente (max 40)','Indirizzo 2 mittente (max 40)','Indirizzo 3 mittente (max 40)','Cap mittente','Citta mittente','Codice nazione mittente','Mail mittente','Prefisso telefono mittente','Tel mittente','Destinatario','Contatto destinatario','Indirizzo 1 destinatario (max 40)','Indirizzo 2 destinatario (max 40)','Indirizzo 3 destinatario (max 40)','Cap destinatario','Citta destinatario','Codice nazione destinatario','Stato sigla ONLY USA','Mail destinatario','Prefisso internazionale destinatario','Telefono destinatario','Peso totale','Colli','Lunghezza','Larghezza','Altezza','Saturday Delivery']
		};
		let today = new Date();
		let groupedData = _.groupBy(this.context.printableItems, (item => item.deliveryNoteId) );
		let warnings = [];
		let outputData = Object.keys(groupedData).map( key => {
			let totalWeight = groupedData[key].reduce( (accumulator, item) => {
				return accumulator + Number(item.grossWeight);
			}, 0);
			let firstItem = groupedData[key][0];
			if (!firstItem.phone) {
				warnings.push(`Il collo #${firstItem.deliveryNoteId} è privo di numero di telefono. Andrà inserito in un secondo momento nel pannello DHL`);
			}
			return [
				this._isItaly(firstItem.country) ? 'DOM' : 'ECX'
				,this._getDateStr(firstItem.deliveryNoteDate) //today?
				,'G'
				,0
				,'EUR'
				,OUR_CLIENT_CODE
				,firstItem.deliveryNoteId
				,'omaggi natalizi'
				,'ENOTECA RICCIARDI'
				,'Rosy'
				,'VIA BARTOLOMEO D ALVIANO 5'
				,''
				,''
				,'20146'
				,'MILANO'
				,'IT'
				,'enoteca.ricciardi@gmail.com'
				,'39'
				,'028 940 2627'
				,firstItem.recipient
				,firstItem.attention
				,firstItem.address
				,''
				,''
				,firstItem.zip
				,firstItem.city
				,firstItem.country
				,''
				,''
				,this._getPhonePrefix(firstItem.phone)
				,this._getPhoneNo(firstItem.phone)
				,Number(totalWeight.toFixed(1))
				,firstItem.packagesTot
				,1
				,1
				,1
				,'N'
			];
		});
		if (warnings.length > 0) {
			Modal.warning({
				content: (
					<Result status="warning" title="Attenzione"
						subTitle={ warnings.map( warning => <div>{warning}</div> ) }
					/>
				)
				,width: '60%'
			});
		}
		CSVStringify(outputData, stringifierOptions, (err, output) => {
			//console.log(output);
			let blob = new Blob([output], {type: 'text/csv;charset=utf-8'});
			saveAs(blob, `spedizioni-dhl-${moment(today).format('YY-MM-DD-HHmmss-SSSS')}.csv`);
		});
	};

	exportXlsDHL = () => {
		let header = ['Destinatario', 'Indirizzo', 'CAP', 'Località', 'Provincia / Stato estero', 'Nazione', 'Persona di riferimento', 'Telefono', 'Email', 'Tipo spedizione', 'Colli', 'Peso', 'Volume mc', 'Vostro riferimento numerico spedizione', 'Vostro riferimento alfanumerico spedizione', 'Importo contrassegno', 'Tipo incasso contrassegno', 'Valore assicurazione', 'Descrizione merce', 'note', 'valore doganale', 'Origine merce', 'Valuta', 'Oneri doganali', 'Documenti'];
		let today = new Date();
		let groupedData = _.groupBy(this.context.printableItems, (item => item.deliveryNoteId) );
		let warnings = [];
		let outputData = Object.keys(groupedData).map( key => {
			let totalWeight = groupedData[key].reduce( (accumulator, item) => {
				return accumulator + Number(item.grossWeight);
			}, 0);
			let notesArr = groupedData[key].reduce( (accumulator, item) => {
				if (item.notes && accumulator.indexOf( String(item.notes).trim().toLowerCase() ) === -1) {
					accumulator.push( String(item.notes).trim() );
				}
				return accumulator;
			}, []);
			let firstItem = groupedData[key][0];
			if (!firstItem.phone) {
				warnings.push(`Il collo #${firstItem.deliveryNoteId} è privo di numero di telefono. Andrà inserito in un secondo momento nel pannello DHL`);
			}
			return [
				firstItem.recipient ? String(firstItem.recipient).toUpperCase() : ''
				,firstItem.address ? String(firstItem.address).toUpperCase() : ''
				,firstItem.zip ? String(firstItem.zip).toUpperCase() : ''
				,firstItem.city ? String(firstItem.city).toUpperCase() : ''
				,firstItem.provinceIT ? String(firstItem.provinceIT).toUpperCase() : ''
				,firstItem.country ? String(firstItem.country).trim().toUpperCase() : ''
				,firstItem.attention ? String(firstItem.attention).toUpperCase() : ''
				,firstItem.phone
				,'delivery.ricciardi@gmail.com' //email
				,this._isItaly(firstItem.country) ? '0' : '8'
				,firstItem.packagesTot
				,Number(totalWeight.toFixed(1))
				,''
				,firstItem.deliveryNoteId
				,firstItem.deliveryNoteId
				,''
				,''
				,''
				,firstItem.description
				,notesArr.join('. ')
				,''
				,'IT'
				,'EUR'
				,this._isItaly(firstItem.country) ? '' : '1'
				,''
			];
		});
		if (warnings.length > 0) {
			Modal.warning({
				content: (
					<Result status="warning" title="Attenzione"
						subTitle={ warnings.map( warning => <div>{warning}</div> ) }
					/>
				)
				,width: '60%'
			});
		}
		outputData = [ header, ...outputData ];

		let wb = XLSX.utils.book_new();
		let ws = XLSX.utils.aoa_to_sheet(outputData);
		XLSX.utils.book_append_sheet(wb, ws, 'Foglio 1');
		XLSX.writeFile(wb, `spedizioni-dhl-${moment(today).format('YY-MM-DD-HHmmss-SSSS')}.xls`, { bookType: 'biff8' });
	};

	exportCsvDHL2025 = () => {
		let header = ['Destinatario', 'Indirizzo', 'CAP', 'Località', 'Provincia / Stato estero', 'Nazione', 'Persona di riferimento', 'Telefono', 'Email', 'Tipo spedizione', 'Colli', 'Peso', 'Volume mc', 'Vostro riferimento numerico spedizione', 'Vostro riferimento alfanumerico spedizione', 'Importo contrassegno', 'Tipo incasso contrassegno', 'Valore assicurazione', 'Descrizione merce', 'note', 'valore doganale', 'Origine merce', 'Valuta', 'Oneri doganali', 'Documenti'];
		let stringifierOptions = {
			delimiter: ';'
			,header: true
			,columns: header
			,quoted: true
		};
		let today = new Date();
		let groupedData = _.groupBy(this.context.printableItems, (item => item.deliveryNoteId) );
		let warnings = [];
		let outputData = Object.keys(groupedData).map( key => {
			let totalWeight = groupedData[key].reduce( (accumulator, item) => {
				return accumulator + Number(item.grossWeight);
			}, 0);
			let notesArr = groupedData[key].reduce( (accumulator, item) => {
				if (item.notes && accumulator.indexOf( String(item.notes).trim().toLowerCase() ) === -1) {
					accumulator.push( String(item.notes).trim() );
				}
				return accumulator;
			}, []);
			let firstItem = groupedData[key][0];
			if (!firstItem.phone) {
				warnings.push(`Il collo #${firstItem.deliveryNoteId} è privo di numero di telefono. Andrà inserito in un secondo momento nel pannello DHL`);
			}
			return [
				firstItem.recipient ? String(firstItem.recipient).toUpperCase() : ''
				,firstItem.address ? String(firstItem.address).toUpperCase() : ''
				,firstItem.zip ? String(firstItem.zip).toUpperCase() : ''
				,firstItem.city ? String(firstItem.city).toUpperCase() : ''
				,firstItem.provinceIT ? String(firstItem.provinceIT).toUpperCase() : ''
				,firstItem.country ? String(firstItem.country).trim().toUpperCase() : ''
				,firstItem.attention ? String(firstItem.attention).toUpperCase() : ''
				,firstItem.phone
				,'delivery.ricciardi@gmail.com' //email
				,this._isItaly(firstItem.country) ? '0' : '8'
				,firstItem.packagesTot
				,Number(totalWeight.toFixed(1))
				,''
				,firstItem.deliveryNoteId
				,firstItem.deliveryNoteId
				,''
				,''
				,''
				,firstItem.description
				,notesArr.join('. ')
				,''
				,'IT'
				,'EUR'
				,this._isItaly(firstItem.country) ? '' : '1'
				,''
			];
		});
		if (warnings.length > 0) {
			Modal.warning({
				content: (
					<Result status="warning" title="Attenzione"
						subTitle={ warnings.map( warning => <div>{warning}</div> ) }
					/>
				)
				,width: '60%'
			});
		}

		CSVStringify(outputData, stringifierOptions, (err, output) => {
			//console.log(output);
			let blob = new Blob([output], {type: 'text/csv;charset=utf-8'});
			saveAs(blob, `spedizioni-dhl-${moment(today).format('YY-MM-DD-HHmmss-SSSS')}.csv`);
		});
	};
	
	/*exportXlsFormat2 = () => {
		let today = new Date();
		let workbook = this.getXLSWorkbook('format2');
		XLSX.writeFile(workbook, `spedizioni-mboxes-${moment(today).format('YY-MM-DD-HHmmss-SSSS')}.xlsx`);
	}*/

	render() {
		if (this.context.printableItems.length == 0){
			return <Redirect to='/' />
		}
		let items = this.context.printableItems;
		return (
			<div>
				<h3>You are exporting:</h3>
				{ items.map( (item, index) => (
					<div key={index}>Delivery Note: {item.deliveryNoteId} - Date: { moment(item.deliveryNoteDate).format('YYYY-MM-DD') }
						&nbsp;- Client: { item.client } - Recipient: { item.recipient }
						&nbsp;- Package {item.packageSeq} of {item.packagesTot}
					</div>
				) ) }
				<div style={{marginTop: 30}} className='action-bar'>
					<Button type="primary" onClick={this.exportCsvDHL2025} icon="download">Export myDHL csv (2025 format)</Button>
					<Button type="primary" onClick={this.exportXlsDHL} icon="download">Export myDHL (2022 format)</Button>
					{/*<Button type="primary" onClick={this.exportCsvUPS} icon="download">Export UPS ??? (2020 format)</Button>*/}
					{/*<Button type="primary" onClick={this.exportXlsFormat1} icon="download">Export XLSX (2019 format)</Button>*/}
					{/*<Button type="primary" onClick={this.exportXlsFormat1} icon="file-excel">Export (DHL, UPS, ...)</Button>
					{/*<Button type="primary" onClick={this.exportXlsFormat2} icon="file-excel" style={{marginLeft: 15}}>Export (Mailboxes)</Button>*/}
				</div>
			</div>
		);
	}
}

export {
	ExportData
}
